
import { george, pr, React, theme, ui } from "aaa";
import { NativeFlatButton } from "components/common/NativeFlatButton";
import { NativeModal } from "components/common/NativeModal";
import { IPhoneOption } from "types/signing";

export class ChoosePhoneDialog extends React.Component<{
    show: boolean,
    isLoading: boolean,
    phoneOptions?: IPhoneOption[],
    onOption: (phoneOption: IPhoneOption) => void,
    onCancel: () => void,
}> {
    componentDidUpdate() {
        ui.isPopupVisible = this.props.show;
    }

    componentDidMount() {
        ui.isPopupVisible = this.props.show;
    }

    render() {
        const phones = this.props.phoneOptions ? this.props.phoneOptions.map((phoneOption, index) => {
            return (
                <div
                    key={phoneOption.id}
                    onClick={() => this.props.onOption(phoneOption)}
                    role="button"
                    style={{ cursor: "pointer" }}
                >
                    <pr.P_18_TITLE style={{ padding: theme.MARGIN }}>{phoneOption.alias} {phoneOption.number}</pr.P_18_TITLE>
                    <pr.LightSeparatorLine />
                </div>
            );
        }) : null;

        return (
            <NativeModal
                open={this.props.show}
                paperStyle={{ borderRadius: theme.BORDER_RADIUS }}
                bodyStyle={{ padding: 0 }}
                contentStyle={{ width: "95%", maxWidth: theme.MAX_APP_WIDTH }}
            >
                <pr.A11yRefocus>
                    <pr.BoldLabel style={{ padding: theme.MARGIN }}>
                        {ui.__("signing.choose.phone")}
                    </pr.BoldLabel>
                </pr.A11yRefocus>

                {!this.props.isLoading && phones}
                {
                    this.props.isLoading &&
                    <div style={{ paddingBottom: 50, paddingTop: 50 }}>
                        <george.LoadingIndicator isLoading={this.props.isLoading} />
                    </div>
                }

                <br />
                <pr.HCenterDiv style={{ marginBottom: theme.MARGIN }}>
                    <NativeFlatButton
                        onClick={() => this.props.onCancel()}
                        disabled={this.props.isLoading}
                    >
                        <pr.BoldLabel style={{ color: theme.customColors.georgeBlue }}>
                            {ui.__("signing.button.cancel")}
                        </pr.BoldLabel>
                    </NativeFlatButton>
                </pr.HCenterDiv>
            </NativeModal >
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/signing/views/ChoosePhoneDialog.tsx